import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';


export const ButtonContainer = styled.div`
    // height: 100%;
    width: 100%;

    max-height: 4rem;
    max-width: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

`;

const LabelText= styled.label`
  font-family: Titillium Web;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  padding-top: 0.5rem;
  line-height: 21px;
  cursor: pointer;
`;

export const IconOverlay = styled(FontAwesomeIcon)`
    color: #2E394F;
    font-size: 18px;
    line-height: 18px;
    margin-right: 7px;
    cursor: pointer;
     &:hover{
    color: white;
    }
   
    
`;
export default class CloseButton extends Component {
    static propTypes = {
        onClick: PropTypes.func
    }

    render() {
        const { onClick, size } = this.props;
        return (
            <ButtonContainer onClick={onClick}>
                <IconOverlay id='timesIcon' icon={faTimes}/>
                <LabelText className="fa-fw">CLOSE</LabelText>
            </ButtonContainer>
        )
    }
}
